import { _ } from "~/i18n";
import { node } from "~/util/dom";

export function createRouteSummaryPopup() {
	const container = node("div", { className: "ui-route-summary-popup" });
	// text od startu vyplnovany zvenci
	const fromStart = node("span");
	// cast od startu
	const fromStartContainer = node("p");
	// text do cile
	const toFinish = node("span");
	// cast do cile
	const toFinishContainer = node("p");
	// fake marker
	const marker = node("img", { src: "/img/marker/little.png" });
	// karta s infem
	const card = node("div", { className: "ui-route-summary-popup__card" });
	// oddelovac
	const divider = node("div", { className: "ui-route-summary-popup__divider" });

	// sestavime levou a pravou cast
	fromStartContainer.append(fromStart, node("span", {}, _("route.geometry.marker.from").replace(" ", String.fromCharCode(160))));
	toFinishContainer.append(toFinish, node("span", {}, _("route.geometry.marker.to").replace(" ", String.fromCharCode(160))));

	container.append(card, marker);
	card.append(fromStartContainer, divider, toFinishContainer);

	return {
		container,
		fromStart,
		toFinish,
	};
}
